import type React from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { Translate, TranslateHtml, useI18n } from '@change-corgi/core-react/i18n';

import { createAnchorToLinkReplacer } from '#src/shared/ds';

import type { ReportType } from '../shared/types';
import { WIRE_REPORT_TYPE } from '../shared/wireReportType';

type Props = {
	type: ReportType;
};

export const Footer: React.FC<Props> = ({ type }) => {
	const { translate } = useI18n();
	const wireType = WIRE_REPORT_TYPE[type];

	const notice = translate(`fe.components.${wireType}_report_abuse.notice`, {
		tosUrl: '',
		cgUrl: '',
	});

	// for some reason, sometimes the i18n label contains the <a> tag, sometimes not...
	if (!notice.includes('<a')) {
		return (
			<Text as="div" size="small" className="text-typography-weak mt-2">
				<TranslateHtml
					value={`fe.components.${wireType}_report_abuse.notice`}
					// TODO process the generated links into @change-corgi/core Link?
					replacements={{
						tosUrl: (
							<Link href="/policies/terms-of-service" variant="secondary" size="small" className="text-typography-weak">
								<Translate value="fe.pages.terms_of_service.title" />
							</Link>
						),
						cgUrl: (
							<Link href="/policies/community" variant="secondary" size="small" className="text-typography-weak">
								<Translate value="fe.pages.community_guidelines.title" />
							</Link>
						),
					}}
				/>
			</Text>
		);
	}

	return (
		<Text as="div" size="small" className="text-typography-weak mt-2">
			<TranslateHtml
				value={`fe.components.${wireType}_report_abuse.notice`}
				// TODO process the generated links into @change-corgi/core Link?
				replacements={{
					tosUrl: '/policies/terms-of-service',
					cgUrl: '/policies/community',
				}}
				replace={createAnchorToLinkReplacer()}
			/>
		</Text>
	);
};
